import React, {useEffect} from 'react';
import Select from "../../UI/Select";
import SearchSelect from "../../UI/Selects/SearchSelect";
import {useRegistry} from "../../../utilities/contexts/registry-context";
import useAsync from "../../../utilities/customHooks/async-call";
import parseOptions from "../../../utilities/data/parseOptions";
import {doGetClients, doGetLotsGroups} from "../../../logics/registry";

const LotCategorySelect = ({classname, ...props}) => {
    const {lotsGroups, loadLotsGroups} = useRegistry();

    useEffect(() => {
        const load = async () => {
            if (!lotsGroups || !lotsGroups.length > 0) {
                const lotsGroups = await doGetLotsGroups();
                if (!lotsGroups) return
                console.log("these are lots groups", lotsGroups);
                loadLotsGroups(lotsGroups.data);
            }
        }
        load();
    }, []);

    return (
        <Select className={classname} {...props}>
            <option value="" selected={true}>Seleziona gruppo</option>
            {lotsGroups.map((lotsGroup, index) => <option key={index} value={lotsGroup}>{lotsGroup}</option>)}
        </Select>
    );
};

export default LotCategorySelect;
